
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { DisenioFacturas } from "../../layout";
import { ActualizarImagenes, ModalFormUno, ModalVerImagen, TarjetasOpciones } from "../../components";
import { useQueryClient } from "@tanstack/react-query";
import { useModalesStore } from "../../../store";
import { startAgregarFacturaABodega } from "../../../services";
import { DetalleDeFactura } from "../../components/facturas";
import { useFacturaXID } from "../../../hooks";

import Swal from "sweetalert2";




export const OpcionesFactura = () => {
    

    const { id } = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { data } = useFacturaXID(id);
    const { activoMoval, changeEstadoModalUno, changeEstadoModalImagen } = useModalesStore(); 
    const [cargando, setCargando] = useState(false);

    
    const handleNavegar = (url) => {
        navigate(`/admin/cencos/${id}/${url}`)
    }


    const handleIngresarABodega = async() => {
        const result = await Swal.fire({
            title: `Ingresar A Bodega Principal`,
            text: `¿Esta seguro de ingresar esta factura?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Crear`,
            cancelButtonText: 'Cancelar'
        });
        if (!result.isConfirmed) return;
        
        setCargando(true);
        const resp = await startAgregarFacturaABodega(id);
        setCargando(false);
        if( resp ){ queryClient.invalidateQueries({queryKey: ['list-facturas']}); }
    }



    const datos = [
        {key:1, titulo:'Ingresar a Bodega Principal', function: handleIngresarABodega, url:'aa', icono:'terminada'},
        {key:2, titulo:'Detalles del Pedido', function:() => changeEstadoModalUno(true, 'detalles'), url:'a', icono:'ver'},
        {key:3, titulo:'Subir Imagen', function:() => changeEstadoModalUno(true, 'editar-imagen'), url:'a', icono:'subirimg'},
        {key:4, titulo:'Ver Imagen', function:() => changeEstadoModalImagen(true), url:'aa', icono:'imagen'},
    ];



    return (

        <DisenioFacturas titulo="Opciones de Factura" url={1}>
            <Grid container spacing={3} sx={{mt:1}}>
                {datos.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>


            {(activoMoval === 'detalles') &&
                <ModalFormUno titulo={`Factura #${data?.numero}`} valor={data} onClose={() => changeEstadoModalUno(false)}>
                    <DetalleDeFactura data={data} />
                </ModalFormUno>
            }


            {(activoMoval === 'editar-imagen') &&
                <ModalFormUno titulo={`Factura #${data?.numero}`} valor={data} onClose={() => changeEstadoModalUno(false)}>
                    <ActualizarImagenes 
                        img={data.img || null}
                        carpeta='facturas'
                        campo='img' tipo='factura'
                        query="factura-id"
                    />
                </ModalFormUno>
            }


            <ModalVerImagen img={data?.img} carpeta='facturas' />
            
        </DisenioFacturas>

    )
}
